import React, { Component } from "react";
import { withRouter } from "./withRouter";
import mapboxgl from "maplibre-gl";
import { tableFromIPC } from "apache-arrow";
import { Typography,Box, Stack, Select, Avatar,TextField,
    FormControl, InputLabel, MenuItem
 } from "@mui/material";
import MapComponent from "./MapComponent"
import ScatterDemogsChart from "./ScatterDemogsChart"
import { rowsFromTable } from "./utils/arrowUtils";
import { makeHeatScale, make2pointHeatScale } from "./utils/colorUtils";
import { buildLabelsAndColors, votePickerOptions } from "./constants/partyConfig";
import { withAccess } from "./access/AccessContext";



/** Picker options for this user. Coalition is a bloc aggregate — internal only. */
const partyOptionsFor = (access) =>
  votePickerOptions(access?.visible_parties, { includeCoalition: !!access?.is_internal });

class NZ2026SeatComparison extends Component {
      constructor(props) {
    super(props);
    this.state = {
      geoLevel: "constituency",
      metricRows: null, 
      loading: false,
      hoverInfo: null,
      hoverAreaId: null,
      selectedStateBounds: null,
      selectedFeature: null,   
      geoData:props.constituencyMap,
      styleLoaded: false,
      viewState: null,
      metricRowsConst: null,
      metricRowsNational:null,
      chosenParty: partyOptionsFor(props.access)[0]?.value ?? "coalition",
      chosenView:"change",
      scatterDemogsRows:null,
      waveOptions: [1,2,3],
      waveSelect:3
    };
    
    this.mapRef = React.createRef();
    this._inflight = null; 
    this._lastKey = null;
    this._lastAt = 0;

    
  }

  
  componentDidMount() {
  const run = async () => {
    await this.fetchMetrics("national", null, true);
    await this.fetchMetrics("constituency", null, true);
    this.fetchDemogsForScatter()
  };
  run();
}

   componentDidUpdate(prevProps, prevState) {
    const groupChanged      = prevProps.selectedGroupId !== this.props.selectedGroupId;
   
    const levelChanged      = prevState.geoLevel !== this.state.geoLevel;

    const chosenPartychange = prevState.chosenParty !== this.state.chosenParty;
    const chosenViewchange = prevState.chosenView !== this.state.chosenView;
  const waveChanged    = prevState.waveSelect !== this.state.waveSelect;

  
    const needRefetch = levelChanged  || groupChanged ;
    if (needRefetch) {
      this.fetchMetrics(this.state.geoLevel, this.state.selectedFeature?.area_id);
    }

  
    const rowsChanged  = prevState.metricRows !== this.state.metricRows;
    const geoChanged   = prevState.geoData !== this.state.geoData;
  
    if (geoChanged || rowsChanged || groupChanged || chosenPartychange ||chosenViewchange||waveChanged) {
      this.restyle();
    }
  
   
    
  }
  _inflightBaseline = null;
  _lastBaselineKey = null;
  _lastBaselineAt = 0;
    requestKey = (level) => {

    return `${level}`;
  };


  //main function that grabs data
    fetchMetrics = async (level, constCode, save_const_results) => {
  const controller = new AbortController(); // new controller for this call
  const signal = controller.signal;

  const reqKey = this.requestKey(level);
  const now = Date.now();
  if (this._lastKey === reqKey && now - this._lastAt < 700) return;
  this._lastKey = reqKey;
  this._lastAt = now;


    let keysBody 
    if(level==="national"){
          keysBody= [
                    "nat_pred_n",
                    "lab_pred_n",
                    "act_pred_n",
                    "nzf_pred_n",
                    "green_pred_n",
                    "tpm_pred_n",
                    "top_pred_n",
                    "oth_pred_n",
                    "inflation_issue_n",
                    "health_issue_n",
                    "econ_issue_n",
                    "crime_issue_n",
                    "housing_issue_n",
                    "poverty_issue_n",
                    "unemployment_issue_n",
                    "climate_issue_n",
                    "education_issue_issue_n",
                    "transport_issue_n",
                    "drugs_issue_n",
                    "race_rel_issue_n",
                    "tax_issue_n",
                    "pollution_issue_n",
                    "maori_issue_n",
                    "immigration_issue_n",
                    "defence_issue_n",
                    "gov_good_n",
                    "gov_bad_n",
                    "gov_dn_n"
                  ]  
    }else{
    keysBody= [
                    "nat_pred_n",
                    "lab_pred_n",
                    "act_pred_n",
                    "nzf_pred_n",
                    "green_pred_n",
                    "tpm_pred_n",
                    "top_pred_n",
                    "oth_pred_n"
                  ]
                }
                
     let turnout_weight
    turnout_weight = "turnout_1_n"

    const body = {
      groupKeys: keysBody,
      filters:[],
      constCode: constCode,
      turnout_weight:turnout_weight
    };
  
    this.setState({ loading: true });
  

 
    try {
      // --- call main metrics endpoint ---
          const resMain = await fetch(`/api/${level}_data_arrow/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body),
                signal,
                });
      if (!resMain.ok) throw new Error(`metrics fetch ${resMain.status}`);
      const bufMain = await resMain.arrayBuffer();
      const tableMain = tableFromIPC(bufMain);
      const rowsMain = rowsFromTable(tableMain);
      // --- update state with both ---
      if(save_const_results){
        if(level==="national"){
          this.setState(
             { metricRowsNational: rowsMain })
            }else{
            this.setState(
            { metricRowsConst: rowsMain ,
                metricRows: rowsMain,})
            }
      }else{
           this.setState({
        metricRows: rowsMain,
        loading: false,
        
      });
      }
   
    } catch (e) {
      if (e.name !== "AbortError") console.error("metrics error:", e);
      this.setState({ metricRows: null,  loading: false });
    } finally {
      this._inflight = null;
    }

  }


  //main function that grabs data
    fetchDemogsForScatter = async () => {
  const controller = new AbortController(); // new controller for this call
  const signal = controller.signal;



    const body = {
      table: "demogs_scatter"
    };
  
    this.setState({ loading: true });
  

 
    try {
      // --- call main metrics endpoint ---
          const resMain = await fetch(`/api/fulltable_data_arrow/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body),
                signal,
                });
      if (!resMain.ok) throw new Error(`metrics fetch ${resMain.status}`);
      const bufMain = await resMain.arrayBuffer();
      const tableMain = tableFromIPC(bufMain);
      const rowsMain = rowsFromTable(tableMain);
          this.setState(
             { scatterDemogsRows: rowsMain })
   
    } catch (e) {
      if (e.name !== "AbortError") console.error("metrics error:", e);
      this.setState({ scatterDemogsRows: null,  loading: false });
    } finally {
      this._inflight = null;
    }

  }
restyle = () => {
  const { geoData, metricRows } = this.state;

  if (!geoData) {
    this.setState({ styledGeo: null });
    return;
  }
  if (!metricRows) {
    return;
  }

  const currentWave = Number(this.state.waveSelect);
  const prevWave = currentWave - 1;

  const filteredMetricRows = metricRows.filter(
    (g) => Number(g.wave) === currentWave
  );
  const byId = new Map();
  for (const r of filteredMetricRows) {
    const id = String(r.area_id ?? "");
    if (id) byId.set(id, r);
  }

  // Previous wave lookup
  const prevById = new Map();
  if (prevWave >= 1) {
    const prevRows = metricRows.filter(
      (g) => Number(g.wave) === prevWave
    );
    for (const r of prevRows) {
      const id = String(r.area_id ?? "");
      if (id) prevById.set(id, r);
    }
  }

  let heatScale;
  let heatKey;

  const { labels, colors } = buildLabelsAndColors();

  heatKey = this.state.chosenParty;

  const groupKeys = [
    "nat_pred_n",
    "lab_pred_n",
    "act_pred_n",
    "nzf_pred_n",
    "green_pred_n",
    "tpm_pred_n",
                    "top_pred_n",
    "oth_pred_n",
  ];

  // Build geo-props lookup for baseline values used in change calculation
  const geoPropsById = new Map();
  for (const f of geoData.features) {
    const rid = String(f.properties?.area_id ?? "");
    if (rid) geoPropsById.set(rid, f.properties);
  }

  // Build scale from ALL waves so colours are consistent when switching waves
  const allWaveValues = metricRows.map((row) => {
    const rid = String(row.area_id ?? "");
    const geoProps = geoPropsById.get(rid);

    if (this.state.chosenView === "pred") {
      if (heatKey === "coalition") {
        return Number(row["nat_pred_n"]) + Number(row["act_pred_n"]) + Number(row["nzf_pred_n"]);
      } else {
        return Number(row[heatKey]);
      }
    } else {
      if (heatKey === "coalition") {
        return geoProps
          ? Number(row["nat_pred_n"]) + Number(row["act_pred_n"]) + Number(row["nzf_pred_n"]) -
              (Number(geoProps["nat_pred_n"]) + Number(geoProps["act_pred_n"]) + Number(geoProps["nzf_pred_n"])) * 100
          : NaN;
      } else {
        return geoProps ? Number(row[heatKey]) - Number(geoProps[heatKey]) * 100 : Number(row[heatKey]);
      }
    }
  });

  const base = colors[heatKey] || "#6e6e6e";

  heatScale =
    this.state.chosenView === "change"
      ? make2pointHeatScale("#2E7D32", "#C62828", allWaveValues)
      : makeHeatScale(base, allWaveValues);

  const noDataProps = {
    fillColor: "#ffffff",
    topLabel: "No data",
    topValue: 0,
    _allValues: {},
    _allValuesSorted: [],
    _diffValues: {},
    _diffValuesSorted: [],
    _diffTurnout: null,
    _hasPrevWave: prevWave >= 1 && prevById.size > 0,
  };

  const styled = {
    type: "FeatureCollection",
    features: geoData.features.map((f) => {
      const rid = String(f.properties?.area_id ?? "");
      const row = byId.get(rid);
      const prevRow = prevById.get(rid);

      if (!row) {
        return {
          ...f,
          properties: { ...f.properties, ...noDataProps },
        };
      }

      const displayKeys = groupKeys.filter((k) => k in row);
      if (displayKeys.length === 0) {
        return {
          ...f,
          properties: { ...f.properties, ...noDataProps },
        };
      }

      const entries = displayKeys
        .map((k) => ({
          key: k,
          area_name: labels[k] || k,
          area_id: Number(row[k]),
        }))
        .filter((e) => Number.isFinite(e.area_id))
        .sort((a, b) => b.area_id - a.area_id);

      let fillColor = "#666";
      let topKey = entries[0]?.key;
      let topLabel = entries[0]?.area_name || "";
      let topValue = entries[0]?.area_id || 0;

      let v;

      if (this.state.chosenView === "pred") {
        if (heatKey === "coalition") {
          v = Number(row["nat_pred_n"]) + Number(row["act_pred_n"]) + Number(row["nzf_pred_n"]);
        } else {
          v = Number(row[heatKey]);
        }
      } else {
        if (heatKey === "coalition") {
          v =
            Number(row["nat_pred_n"]) + Number(row["act_pred_n"]) + Number(row["nzf_pred_n"]) -
            (Number(f.properties?.["nat_pred_n"]) + Number(f.properties?.["act_pred_n"]) + Number(f.properties?.["nzf_pred_n"])) * 100;
        } else {
          v = f.properties?.[heatKey] ? Number(row[heatKey]) - Number(f.properties?.[heatKey]) * 100 : Number(row[heatKey]);
        }
      }

      fillColor = heatScale(v);
      topKey = heatKey;
      topLabel = entries[0]?.area_name || "";
      topValue = Number.isFinite(v) ? v : 0;

      const sortedvals = entries
        .map((e) => ({
          ...e,
          order: e.key === "Net" ? Number.MAX_SAFE_INTEGER : 0,
        }))
        .sort((a, b) => a.order - b.order)
        .map((e) => ({ key: e.key, area_name: e.area_name, area_id: e.area_id }));

      // --- Wave-on-wave diffs ---
      let diffEntries = [];
      if (prevRow) {
        diffEntries = displayKeys
          .map((k) => {
            const curr = Number(row[k]);
            const prev = Number(prevRow[k]);
            const diff =
              Number.isFinite(curr) && Number.isFinite(prev) ? curr - prev : null;
            return { key: k, area_name: labels[k] || k, area_id: diff };
          })
          .filter((e) => e.area_id !== null);
      }

      const diffSorted = diffEntries
        .map((e) => ({
          ...e,
          order: e.key === "Net" ? Number.MAX_SAFE_INTEGER : 0,
        }))
        .sort((a, b) => a.order - b.order)
        .map((e) => ({ key: e.key, area_name: e.area_name, area_id: e.area_id }));

      return {
        ...f,
        properties: {
          ...f.properties,
          fillColor,
          topKey,
          topLabel,
          topValue,
          _allValues: Object.fromEntries(entries.map((e) => [e.key, e.area_name, e.area_id])),
          _allValuesSorted: sortedvals,
          Turnout: row?.turnout_1_p,
          _diffValues: Object.fromEntries(diffEntries.map((e) => [e.key, e.area_name, e.area_id])),
          _diffValuesSorted: diffSorted,
          _diffTurnout:
            prevRow && row?.turnout_1_p != null && prevRow?.turnout_1_p != null
              ? Number(row.turnout_1_p) - Number(prevRow.turnout_1_p)
              : null,
          _hasPrevWave: !!prevRow,
        },
      };
    }),
  };

  this.setState({ styledGeo: styled, styleLoaded: true });
};
  fitBoundsFromFeatures = (features) => {
  if (!this.mapRef.current || !features?.length) return null;
  const map = this.mapRef.current.getMap();
  const bounds = new mapboxgl.LngLatBounds();
  this.setState({viewState:null})
  features.forEach(f => {
    const coords = f.geometry.type === "Polygon"
      ? f.geometry.coordinates.flat(1)
      : f.geometry.coordinates.flat(2);
    coords.forEach(([lng, lat]) => bounds.extend([lng, lat]));
  });
  map.fitBounds(bounds, { padding: 28, duration: 500 });
  return bounds;
};

  

   onMapClick = (evt) => {
    const feature = evt.features?.[0];
    if (!feature) return;
    const level = this.state.geoLevel;
    const p = feature.properties || {};
    const areaId = String(p.area_id ?? "");
    const map = this.mapRef.current?.getMap();


    const zoomToFeature = (feat) => this.fitBoundsFromFeatures([feat]);

    

    const clickedLevel = level;

    if (
      areaId &&
      this.state.selectedFeature &&
      this.state.selectedFeature.level === clickedLevel &&
      this.state.selectedFeature.area_id === areaId
    ) {
      this.setState({ selectedFeature: null }, () => {
        if (this.state.selectedStateBounds) {
          map?.fitBounds(this.state.selectedStateBounds, { padding: 28, duration: 500 });
        } else {
         // map?.fitBounds([[-125, 24], [-66, 49]], { padding: 20, duration: 500 });
        }

        this.props.onFeatureSelect?.({
          feature: null,
          selectedAreaLabel: null,
          selectedFeatureLevel: null,
        });
      });
      return;
    }

     if (level === "constituency") {
      const constCode = String(p.area_id || "")
      if (!constCode) return;
  
      const stateBounds = zoomToFeature(feature); // sets map to state
      const stateLabel =  p.area_name;
  
      this.setState(
        {
          selectedconstCode: constCode,
          selectedStateBounds: stateBounds,
          geoLevel: "SA3",
          // Keep selectedFeature pointing to the state context
          selectedFeature: {
            level: "constituency",
            key: "STATEFP",
            area_id: constCode,
            area_name: stateLabel,
            rowMatchIds: [constCode],
          },
        },
        () => {
          // Make sure county metrics (and secondary metrics) are loaded for tooltips
          this.fetchMetrics("SA3",constCode );
          // Load county geo for that state (no auto-fit; we already zoomed)
          this.loadGeo("SA3", { doFit: false });
                
  
        }
      );
      return;
    }


  };

      onMouseMove = (evt) => {
        const feature = evt.features && evt.features[0];
        if (!feature) return this.setState({ hoverInfo: null,hoverAreaId:null });
    
        const { lng, lat } = evt.lngLat; 
        this.setState({
        hoverInfo: { lon: lng, lat, props: feature.properties },
        hoverAreaId: feature.properties.area_id ?? null
        });
    };

  loadGeo = async (level) => {
    let newGeo 
    switch(level){
        case "constituency":
         newGeo = this.props.constituencyMap
        break
        case "SA3":
         newGeo = this.props.SA3Map
        break
        case "SA2":
         newGeo = this.props.SA2Map
        break
        default:
         newGeo = this.props.constituencyMap
        break
    }
    this.setState({geoData: newGeo, geoLevel: level
    })
  }

 onGeoLevelChange = (newLevel) => {
  if (!newLevel) return;

  // if these are async functions already, await them
  this.fetchMetrics(newLevel, this.state.selectedFeature?.area_id);
  this.loadGeo(newLevel);

  // return when both finish
};
    // Utility: compute bounds [minX, minY, maxX, maxY] from a FeatureCollection
getFeatureCollectionBounds = (featureCollection) => {
  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;

  featureCollection.features.forEach((feat) => {
    const coords = feat.geometry.coordinates;

    const recurse = (arr) => {
      if (typeof arr[0] === "number") {
        const [x, y] = arr;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
      } else {
        arr.forEach(recurse);
      }
    };

    recurse(coords);
  });

  return [[minX, minY], [maxX, maxY]];
};
    

   resetView = ({ LevelToResetTo = "constituency" }) => {
    const map = this.mapRef.current?.getMap();
    if (map) {
    map.fitBounds(
      [
        [166.0, -47.5], // SW
        [179.0, -33.0], // NE
      ],
      { padding: 80 }
    );
  }

  this.setState(
    {
      geoLevel: LevelToResetTo,
      selectedStateCode: null,
      selectedStateBounds: null,
      selectedFeature: null,
      metricRows: null,
      styledGeo: null,
            
    },
    () => {
      this.onGeoLevelChange(LevelToResetTo);

    }
  );
};

handleselectedFeatureChange =  (area_id, area_name) => {

  


    const feature = this.props.constituencyMap.features.filter(
          f => String(f.properties.area_id) === String(area_id.area_id)
        )[0];
    if (!feature) return;
    const level = this.state.geoLevel;
    const p = feature.properties || {};
    const areaId = String(p.area_id ?? "");
    const map = this.mapRef.current?.getMap();

    const zoomToFeature = (feat) => this.fitBoundsFromFeatures([feat]);   

    const clickedLevel = level;


    if (
      areaId &&
      this.state.selectedFeature &&
      this.state.selectedFeature.level === clickedLevel &&
      this.state.selectedFeature.area_id === areaId
    ) {
      this.setState({ selectedFeature: null }, () => {
        if (this.state.selectedStateBounds) {
          map?.fitBounds(this.state.selectedStateBounds, { padding: 28, duration: 500 });
        } else {
         // map?.fitBounds([[-125, 24], [-66, 49]], { padding: 20, duration: 500 });
        }

        this.props.onFeatureSelect?.({
          feature: null,
          selectedAreaLabel: null,
          selectedFeatureLevel: null,
        });
      });
      return;
    }
      const stateBounds = zoomToFeature(feature); // sets map to state

      const constCode = String(p.area_id || "")
      if (!constCode) return;
  
      const stateLabel =  p.area_name;
  
      this.setState(
        {
          selectedconstCode: constCode,
          selectedStateBounds: stateBounds,
          geoLevel: "SA3",
          viewState:null,
          // Keep selectedFeature pointing to the state context
          selectedFeature: {
            level: "constituency",
            key: "area_id",
            area_id: constCode,
            area_name: stateLabel,
            rowMatchIds: [constCode],
            
          },
        },
        () => {
          // Make sure county metrics (and secondary metrics) are loaded for tooltips
          this.fetchMetrics("SA3",constCode );
          // Load county geo for that state (no auto-fit; we already zoomed)
          this.loadGeo("SA3", { doFit: false });
                
  
        }
      );
      return;
    
 

}
  handlechosenPartyChange     = (val) => this.setState({ chosenParty: val });
  handlechosenViewChange     = (val) => this.setState({ chosenView: val });
      handlewaveSelectChange     = (val) => {
    
    this.setState({ waveSelect: val })
    
  };

  render() {
  const partyOptions = partyOptionsFor(this.props.access);
  // With a single party there is nothing to pick, so a static signifier takes the
  // picker's place and names what is on screen.
  const singleParty = partyOptions.length <= 1;
  const only = partyOptions[0];
  const partyVoteLabel = only
    ? (only.slug ? `${only.fullName} Party Vote` : `${only.fullName} Vote`)
    : "Party Vote";

  return(
    <>
  <Box sx={{ height: "100%", display: "flex", flexDirection: "column", width:'100%' }}>
    {/* HEADER (auto height, no flexGrow) */}
    <Box
      sx={(theme) => ({
        px: 3, py: 3,
        display: "flex", alignItems: "center",
        backgroundColor: theme.vars
          ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
          : theme.palette.background.default,
        borderBottom: `1px solid ${theme.palette.divider}`,
        // no flexGrow, no % height here
      })}
    >
      {/* left: icon + text */}
      <Stack direction="row" spacing={2} alignItems="center" sx={{ ml: 4 }}>
        <Avatar
          variant="square"
          src={`${process.env.PUBLIC_URL}/static/images/logo.png`}
          alt="Projected Vote Shares"
          sx={{
            width: 44, height: 44, flexShrink: 0,
            bgcolor: "transparent",
            "& .MuiAvatar-img": { objectFit: "contain" },
          }}
        />
        <Box>
          <Typography variant="h5" fontWeight={700}>Projected Vote Shares</Typography>
          <Typography variant="body1" color="text.secondary">
            {singleParty
              ? "Switch the view to see predicted vote share or change since 2023"
              : "Select a party from the list below to display their heat maps"}
          </Typography>
        </Box>
      </Stack>

      {/* right: selects */}
      <Stack direction="row" alignItems="center" spacing={2} sx={{ ml: "auto", pr: 4 }}>
           {singleParty ? (
                    // No choice to make, so the picker's slot states what is on screen.
                    <Stack
                      direction="row"
                      alignItems="center"
                      spacing={1}
                      sx={{
                        minWidth: 180,
                        px: 1.5,
                        py: 0.9,
                        borderRadius: 1,
                        border: "1px solid",
                        borderColor: "divider",
                        bgcolor: "background.paper",
                      }}
                    >
                      <Box
                        sx={{
                          width: 10,
                          height: 10,
                          borderRadius: "50%",
                          flexShrink: 0,
                          bgcolor: partyOptions[0]?.color || "#111827",
                        }}
                      />
                      <Typography sx={{ fontWeight: 800, fontSize: "0.95rem", whiteSpace: "nowrap" }}>
                        {partyVoteLabel}
                      </Typography>
                    </Stack>
           ) : (
                    <TextField
                    select
                    label="Party"
                    size="small"
                    value={this.state.chosenParty}
                    onChange={(e) => this.handlechosenPartyChange?.(e.target.value)}
                    sx={{ minWidth: 180 }}
                    >
                    {partyOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                    </TextField>
           )}

                    <TextField
                    select
                    label="View"
                    size="small"
                    value={this.state.chosenView}
                    onChange={(e) => this.handlechosenViewChange?.(e.target.value)}
                    sx={{ minWidth: 180 }}
                    >
                    <MenuItem value="pred">Predicted vote share</MenuItem>
                    <MenuItem value="change">Change since 2023</MenuItem>
                    </TextField>


      </Stack>
    </Box>

    {/* CONTENT: fills the rest, split 50/50 */}
    <Box
      sx={{
        flex: 1,
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        overflow: "hidden",
        width:"100%"
      }}
    >
      {/* LEFT PANEL (map) */}
      <Box sx={{ minWidth: 0, overflow: "hidden" }}>
        <Box sx={{ width: "100%", height: "100%" }}>
          <MapComponent
            mapRef={this.mapRef}
            styledGeo={this.state.styledGeo}
            geoData={this.state.geoData}
            hoverInfo={this.state.hoverInfo}
            styleLoaded={this.state.styleLoaded}
            selectedFeature={this.state.selectedFeature}
            onMapClick={this.onMapClick}
            onMouseMove={this.onMouseMove}
            onGeoLevelChange={this.onGeoLevelChange}
            buildLabelsAndColors={buildLabelsAndColors}
            geoLevel={this.state.geoLevel}
            resetView={this.resetView}
            handleselectedFeatureChange={this.handleselectedFeatureChange}
            viewState={this.state.viewState}
            tooltip = {"seatcomp"}
            chosenView = {this.state.chosenView}
            chosenParty = {this.state.chosenParty}


  //           compareWaves={this.state.compareWaves}
  // onCompareWavesChange={this.handleCompareWavesChange}
  
                waveSelect={this.state.waveSelect}
                handlewaveSelectChange={this.handlewaveSelectChange}
                waveOptions={this.state.waveOptions}
  showWaveBox={true}
          />
        </Box>
      </Box>

      {/* RIGHT PANEL */}
      <Box sx={{ minWidth: 0, overflow: "auto", borderLeft: 1, borderColor: "divider" }}>
        <ScatterDemogsChart
        scatterDemogsRows={this.state.scatterDemogsRows}
        selectedParty={this.state.chosenParty}
                waveOptions={this.state.waveOptions}
        />
      </Box>
    </Box>
  </Box>
</>

  )
}


  }

export default withRouter(withAccess(NZ2026SeatComparison));